import * as $ from "jquery";

import { $body } from 'Core/Body';
import { getCurrentLanguage } from 'Core/Languages';
import { formatCurrency, showPriceWithCurrentCurrency } from 'Core/Currencies';
import { Notifications } from 'Core/Notifications';
import { ValidationModule } from 'Components/Validation/Validation';
import { CartService, CartServiceResponse } from 'Components/Cart/CartService';
import { CartCommon } from 'Components/Cart/CartCommon';
import { Step1Selectors } from 'Components/Cart/Step1/Step1Selectors';
import { Step1Component } from 'Components/Cart/Step1/Step1';
import { Step2Component } from 'Components/Cart/Step2/Step2';
import { Step3Component } from 'Components/Cart/Step3/Step3';
import { FinalComponent } from 'Components/Cart/Final';
import { CartShowMoreBtn } from 'Components/Cart/CartShowMoreBtn';
import { GuestModal } from 'Components/Cart/GuestModal';
import { AddCartModal } from 'Components/Cart/AddCartModal';
import "jquery.cookie";
import { Promotions } from "Components/Promotions";

export const Cart = (() => {
	const Selector = {
		CART_ICON: {
			COUNT: ".js_cart_count",
			VALUE: "#cartValue",
		},

		PRODUCT_TILE: {
			ADD_ITEM: ".js_product_tile_add_to_cart",
		},

		PRODUCT_PAGE: {
			ADD_ITEM: ".js_product_page_add_to_cart",
			QUANTITY: ".js_product_page_quantity",
			ADD_OFFER: ".js_product_page_add_to_offer",
			INCREASER: ".js_product_page_quantity--increaser",
			DECREASER: ".js_product_page_quantity--decreaser",
		},

		CATEGORY_PAGE: {
			ADD_ITEM: '.js_category_page_add_to_cart',
			ADD_OFFER: '.js_category_page_add_to_offer'
		},

		COMMON: {
			REMOVE_ITEM: ".js_remove_from_cart",
		},

		CART: {
			EMPTY_INFO: "#cart_empty",
			DELIVERY_TIME: '#DeliveryTime',

			STEP_3: {
				FORM: '#step3_form'
			}
		}
	};
	const CART_COUNT_LIMIT: number = 50;

	const Message = {
		MAX_PRODUCT_LIMIT: "Wybrano największą możliwą ilość produktu",
		CART_COUNT_LIMIT: "W koszyku możesz mieć maksymalnie " + CART_COUNT_LIMIT + " różnych elementów. Ilość jaką próbujesz dodać do koszyka przekracza limit."
	};
	const { FORM, CLEAR_ALL_PRODUCTS, PRODUCT, SUMMARY_PANEL } = Step1Selectors;
	const lang = getCurrentLanguage;

	function cartChangeHandler(res: CartServiceResponse) {
		if (res.result) {
			if (res.value) {
				$(SUMMARY_PANEL.TOTAL).html(res.value.total.toString());
				if (res.value.count > 0) {
					$(Selector.CART_ICON.COUNT).show().html(res.value.count.toString());
				} else {
					$(Selector.CART_ICON.COUNT).hide().html('0');
					$(Selector.CART.EMPTY_INFO).show(250);
					// Step1 FORM
					$(FORM).hide(250);
				}
				const pure_value: number = CartCommon.prepareResultValueAsFloat(res.value.total);
				$(Selector.CART_ICON.VALUE).html(res.value.total.toString());
				$(SUMMARY_PANEL.TOTAL).attr('data-value', pure_value); //necessary to update delivery bar
				Step1Component.handleDeliveryBarUpdate(pure_value, res);

				// if there are any promotions
				if (res.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency) {
					// then apply the promotion to total price
					if (res.cartThreshold.firstThresholdIsCrossed) {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <s>${showPriceWithCurrentCurrency(Number(res.cartThreshold.currentBasketAmount), 2, 'comma')}</s> <br>
                        <span style="color: green;">
                            Razem po rabacie: <br> 
                            <b>${res.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency}</b>
                        </span>
                        `);
					} else {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <b>${showPriceWithCurrentCurrency(Number(res.cartThreshold.currentBasketAmount), 2, 'comma')}</b>
                        `);
					}

					Promotions.updateValues({
						currentThresholdMin: res.cartThreshold.currentThreshold,
						currentThresholdMax: res.cartThreshold.nextGreatestThreshold,
						remainingAmount: res.cartThreshold.missingAmount,
						currentCartAmount: res.cartThreshold.currentBasketAmount,
						currentThresholdPercent: res.cartThreshold.currentPercent,
						nextThresholdPercent: res.cartThreshold.nextGreatestPercent,
						lastThresholdPercent: res.cartThreshold.lastPercent
					});
				}
			}
			Notifications.add(res.msg, res.type ? res.type : "success");
		} else {
			// Notifications.add('Cart - error', 'error');
		}
	}

	function ProdTileAddToCart(this: HTMLElement) {
		const { productId } = CartCommon.extractCommonData(this);
		const itGoesBeyondCountLimit: boolean = CartCommon.checkBasketLimit(Selector.CART_ICON.COUNT, CART_COUNT_LIMIT);

		if (itGoesBeyondCountLimit) {
			Notifications.add(Message.CART_COUNT_LIMIT, "warning");
		} else {
			CartService.add(lang, productId, 1).done(cartChangeHandler);
		}
	}

	function RemoveFromCart(this: HTMLElement) {
		const { $this, productId } = CartCommon.extractCommonData(this);
		$(this).attr('disabled', 'disabled');
		CartService.remove(lang, productId)
			.done((response) => cartChangeHandler(response))
			.then(() => updateDeliveryTime())
			.then(() => $this.closest(PRODUCT.CONTAINER).remove())
			.then(() => CalcProductsQuantity())
			.then(() => executeTotalCalculations())
		if (PRODUCT.CONTAINER.length == 0) {
			$(CLEAR_ALL_PRODUCTS).hide(250);
			$(FORM).hide(250);
		}
	}

	function ClearAllProductsFromCart() {
		CartService.clear(lang)
			.done((response) => cartChangeHandler(response))
			.then(() => updateDeliveryTime())
			.then(() => $(Selector.CART.EMPTY_INFO).show(250))
			.then(() => $(FORM).hide(250))
		$(Selector.CART_ICON.COUNT).hide().html('0');
		CalcProductsQuantity();
	}

	function IncreaseProdQuantity(this) {
		let currentInput = $(this).next('input')[0];
		let { $this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat } = CartCommon.extractFullCommonData(currentInput);
		let { row, price, total } = CartCommon.extractRowCommonData($this);

		if (quantity.greaterThanOrEqualTo(maxQuantity)) {
			Notifications.add(Message.MAX_PRODUCT_LIMIT, "info");
			return false;
		} else {
			quantity = quantity.plus(step);
			$this.val(quantity.toFixed(unitIsFloat));
			total.text(formatCurrency(price * quantity.toNumber()));
			total.attr('data-total-price', price * quantity.toNumber());
			row.find('button').attr('disabled', 'disabled');
			CartService.update(productId, quantity.toNumber())
				.done($result => {
					const pure_value: number = CartCommon.prepareResultValueAsFloat($result.value.total);
					$this.val(quantity.toFixed(unitIsFloat));
					total.text(formatCurrency(price * quantity.toNumber()));
					total.attr('data-total-price', price * quantity.toNumber());
					row.find('button').removeAttr('disabled');

					$(SUMMARY_PANEL.TOTAL).html(String($result.value.total));
					$(SUMMARY_PANEL.TOTAL).attr('data-value', pure_value); //necessary to update delivery bar
					Step1Component.handleDeliveryBarUpdate(pure_value, $result);
					// if there are any promotions
					// then apply the promotion to total price
					if ($result.cartThreshold.firstThresholdIsCrossed) {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <s>${showPriceWithCurrentCurrency($result.cartThreshold.currentBasketAmount, 2, 'comma')}</s> <br>
                        <span style="color: green;">
                            Razem po rabacie: <br> 
                            <b>${$result.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency}</b>
                        </span>
                        `);
					} else {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <b>${showPriceWithCurrentCurrency($result.cartThreshold.currentBasketAmount, 2, 'comma')}</b>
                        `);
					}
					Promotions.updateValues({
						currentThresholdMin: $result.cartThreshold.currentThreshold,
						currentThresholdMax: $result.cartThreshold.nextGreatestThreshold,
						remainingAmount: $result.cartThreshold.missingAmount,
						currentCartAmount: $result.cartThreshold.currentBasketAmount,
						currentThresholdPercent: $result.cartThreshold.currentPercent,
						nextThresholdPercent: $result.cartThreshold.nextGreatestPercent,
						lastThresholdPercent: $result.cartThreshold.lastPercent
					});
					if ($result.msg != undefined && $result.msg != null) {
						Notifications.add($result.msg, "warning");
					}
				})
		}
	}

	function DecreaseProdQuantity(this) {
		let currentInput = $(this).prev('input')[0];
		let { $this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat } = CartCommon.extractFullCommonData(currentInput);
		let { row, price, total } = CartCommon.extractRowCommonData($this);

		if (quantity.lessThanOrEqualTo(minQuantity)) {
			return false;
		} else {
			quantity = quantity.minus(step);
			$this.val(quantity.toString());
			total.text(formatCurrency(price * quantity.toNumber()));
			total.attr('data-total-price', price * quantity.toNumber());
			row.find('button').attr('disabled', 'disabled');
			CartService.update(productId, quantity.toNumber())
				.done($result => {
					const pure_value: number = CartCommon.prepareResultValueAsFloat($result.value.total);
					$this.val(quantity.toFixed(unitIsFloat));
					total.text(formatCurrency(price * quantity.toNumber()));
					total.attr('data-total-price', price * quantity.toNumber());
					row.find('button').removeAttr('disabled');
					$(SUMMARY_PANEL.TOTAL).html(String($result.value.total));
					$(SUMMARY_PANEL.TOTAL).attr('data-value', pure_value); //necessary to update delivery bar
					Step1Component.handleDeliveryBarUpdate(pure_value, $result);
					// if there are any promotions
					// then apply the promotion to total price
					if ($result.cartThreshold.firstThresholdIsCrossed) {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <s>${showPriceWithCurrentCurrency(Number($result.cartThreshold.currentBasketAmount), 2, 'comma')}</s> <br>
                        <span style="color: green;">
                            Razem po rabacie: <br> 
                            <b>${$result.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency}</b>
                        </span>
                        `);
					} else {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <b>${showPriceWithCurrentCurrency(Number($result.cartThreshold.currentBasketAmount), 2, 'comma')}</b>
                        `);
					}

					Promotions.updateValues({
						currentThresholdMin: $result.cartThreshold.currentThreshold,
						currentThresholdMax: $result.cartThreshold.nextGreatestThreshold,
						remainingAmount: $result.cartThreshold.missingAmount,
						currentCartAmount: $result.cartThreshold.currentBasketAmount,
						currentThresholdPercent: $result.cartThreshold.currentPercent,
						nextThresholdPercent: $result.cartThreshold.nextGreatestPercent,
						lastThresholdPercent: $result.cartThreshold.lastPercent
					});

					if ($result.msg != undefined && $result.msg != null) {
						Notifications.add($result.msg, "warning");
					}
				})
		}
	}

	function inputKeyupHandler(this, event: JQueryEventObject) {
		CartCommon.inputKeyupHandler(this, event, Message.MAX_PRODUCT_LIMIT);
	}

	function changeProductQuantity() {
		CartCommon.changeProductQuantity(this, Selector.PRODUCT_PAGE.QUANTITY, Message.MAX_PRODUCT_LIMIT)
	}

	function focusoutProductPageProductQuantity() {
		CartCommon.focusoutProductPageProductQuantity(this, Message.MAX_PRODUCT_LIMIT);
	}

	function inputFocusoutHandler() {
		CartCommon.inputFocusoutHandler(this);
	}

	function CalcProductsQuantity() {
		let total: number = $(PRODUCT.CONTAINER).length;
		$(SUMMARY_PANEL.PRODS_QUANTITY).text(total);
	}

	function updateDeliveryTime() {
		CartService.getDeliveryTime().done(msg => {
			$(Selector.CART.DELIVERY_TIME).toggle(!!msg).html(msg);
		});
	}

	function calcTotalQuantities() {
		CartCommon.calcTotalQuantities(PRODUCT.QUANTITY);
	}

	function executeTotalCalculations() {
		calcTotalQuantities();
	}

	function sendFormStepOne(e) {
		if (CartCommon.isAllAjaxComplete === true) {
			$body.off("submit", FORM, sendFormStepOne);
			return $(FORM).submit();
		}
		e.preventDefault();
	}

	$body.on("submit", FORM, sendFormStepOne);
	$body.on("click", Selector.PRODUCT_TILE.ADD_ITEM, ProdTileAddToCart);
	// $body.on("click", Selector.CATEGORY_PAGE.ADD_ITEM, ProdPageAddToCart);
	// $body.on("click", Selector.PRODUCT_PAGE.ADD_ITEM, ProdPageAddToCart);
	$body.on("click", Selector.PRODUCT_PAGE.INCREASER, changeProductQuantity);
	$body.on("click", Selector.PRODUCT_PAGE.DECREASER, changeProductQuantity);
	$body.on("focusout", Selector.PRODUCT_PAGE.QUANTITY, focusoutProductPageProductQuantity);
	// Step1 Selectors below
	$body.ready(CalcProductsQuantity);
	$body.on("click", CLEAR_ALL_PRODUCTS, ClearAllProductsFromCart);
	$body.on("click", PRODUCT.REMOVE, RemoveFromCart);
	$body.on("keyup", PRODUCT.QUANTITY, inputKeyupHandler);
	$body.on("keyup", PRODUCT.QUANTITY, executeTotalCalculations);
	$body.on("focusout", PRODUCT.QUANTITY, inputFocusoutHandler);
	$body.on("focusout", PRODUCT.QUANTITY, executeTotalCalculations);
	$body.on("click", PRODUCT.QUANTITY_CONTROL_INCREASE, IncreaseProdQuantity);
	$body.on("click", PRODUCT.QUANTITY_CONTROL_DECREASE, DecreaseProdQuantity);
	$body.on('click', PRODUCT.QUANTITY_CONTROL_INCREASE, executeTotalCalculations);
	$body.on('click', PRODUCT.QUANTITY_CONTROL_DECREASE, executeTotalCalculations);

	return true;
})();

export {
	ValidationModule,
	Step1Component,
	Step2Component,
	Step3Component,
	FinalComponent,
	CartShowMoreBtn,
	GuestModal,
	AddCartModal
}
import * as $ from "jquery";

import { $body } from 'Core/Body';
import { getCurrentLanguage } from 'Core/Languages';
import { formatCurrency, showPriceWithCurrentCurrency } from 'Core/Currencies';
import { Notifications } from 'Core/Notifications';
import { ValidationModule } from 'Components/Validation/Validation';
import { CartService, CartServiceResponse } from 'Components/Cart/CartService';
import { CartCommon } from 'Components/Cart/CartCommon';
import { Step1Selectors } from 'Components/Cart/Step1/Step1Selectors';
import { Step1Component } from 'Components/Cart/Step1/Step1';
import { Step2Component } from 'Components/Cart/Step2/Step2';
import { Step3Component } from 'Components/Cart/Step3/Step3';
import { FinalComponent } from 'Components/Cart/Final';
import { CartShowMoreBtn } from 'Components/Cart/CartShowMoreBtn';
import { GuestModal } from 'Components/Cart/GuestModal';
import { AddCartModal } from 'Components/Cart/AddCartModal';
import "jquery.cookie";
import { Promotions } from "Components/Promotions";

export const Cart = (() => {
	const Selector = {
		CART_ICON: {
			COUNT: ".js_cart_count",
			VALUE: "#cartValue",
		},

		PRODUCT_TILE: {
			ADD_ITEM: ".js_product_tile_add_to_cart",
		},

		PRODUCT_PAGE: {
			ADD_ITEM: ".js_product_page_add_to_cart",
			QUANTITY: ".js_product_page_quantity",
			ADD_OFFER: ".js_product_page_add_to_offer",
			INCREASER: ".js_product_page_quantity--increaser",
			DECREASER: ".js_product_page_quantity--decreaser",
		},

		CATEGORY_PAGE: {
			ADD_ITEM: '.js_category_page_add_to_cart',
			ADD_OFFER: '.js_category_page_add_to_offer'
		},

		COMMON: {
			REMOVE_ITEM: ".js_remove_from_cart",
		},

		CART: {
			EMPTY_INFO: "#cart_empty",
			DELIVERY_TIME: '#DeliveryTime',

			STEP_3: {
				FORM: '#step3_form'
			}
		}
	};
	const CART_COUNT_LIMIT: number = 50;

	const Message = {
		MAX_PRODUCT_LIMIT: "Wybrano największą możliwą ilość produktu",
		CART_COUNT_LIMIT: "W koszyku możesz mieć maksymalnie " + CART_COUNT_LIMIT + " różnych elementów. Ilość jaką próbujesz dodać do koszyka przekracza limit."
	};
	const { FORM, CLEAR_ALL_PRODUCTS, PRODUCT, SUMMARY_PANEL } = Step1Selectors;
	const lang = getCurrentLanguage;

	function cartChangeHandler(res: CartServiceResponse) {
		if (res.result) {
			if (res.value) {
				$(SUMMARY_PANEL.TOTAL).html(res.value.total.toString());
				if (res.value.count > 0) {
					$(Selector.CART_ICON.COUNT).show().html(res.value.count.toString());
				} else {
					$(Selector.CART_ICON.COUNT).hide().html('0');
					$(Selector.CART.EMPTY_INFO).show(250);
					// Step1 FORM
					$(FORM).hide(250);
				}
				const pure_value: number = CartCommon.prepareResultValueAsFloat(res.value.total);
				$(Selector.CART_ICON.VALUE).html(res.value.total.toString());
				$(SUMMARY_PANEL.TOTAL).attr('data-value', pure_value); //necessary to update delivery bar
				Step1Component.handleDeliveryBarUpdate(pure_value, res);

				// if there are any promotions
				if (res.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency) {
					// then apply the promotion to total price
					if (res.cartThreshold.firstThresholdIsCrossed) {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <s>${showPriceWithCurrentCurrency(Number(res.cartThreshold.currentBasketAmount), 2, 'comma')}</s> <br>
                        <span style="color: green;">
                            Razem po rabacie: <br> 
                            <b>${res.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency}</b>
                        </span>
                        `);
					} else {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <b>${showPriceWithCurrentCurrency(Number(res.cartThreshold.currentBasketAmount), 2, 'comma')}</b>
                        `);
					}

					Promotions.updateValues({
						currentThresholdMin: res.cartThreshold.currentThreshold,
						currentThresholdMax: res.cartThreshold.nextGreatestThreshold,
						remainingAmount: res.cartThreshold.missingAmount,
						currentCartAmount: res.cartThreshold.currentBasketAmount,
						currentThresholdPercent: res.cartThreshold.currentPercent,
						nextThresholdPercent: res.cartThreshold.nextGreatestPercent,
						lastThresholdPercent: res.cartThreshold.lastPercent
					});
				}
			}
			Notifications.add(res.msg, res.type ? res.type : "success");
		} else {
			// Notifications.add('Cart - error', 'error');
		}
	}

	function ProdTileAddToCart(this: HTMLElement) {
		const { productId } = CartCommon.extractCommonData(this);
		const itGoesBeyondCountLimit: boolean = CartCommon.checkBasketLimit(Selector.CART_ICON.COUNT, CART_COUNT_LIMIT);

		if (itGoesBeyondCountLimit) {
			Notifications.add(Message.CART_COUNT_LIMIT, "warning");
		} else {
			CartService.add(lang, productId, 1).done(cartChangeHandler);
		}
	}

	function RemoveFromCart(this: HTMLElement) {
		const { $this, productId } = CartCommon.extractCommonData(this);
		$(this).attr('disabled', 'disabled');
		CartService.remove(lang, productId)
			.done((response) => cartChangeHandler(response))
			.then(() => updateDeliveryTime())
			.then(() => $this.closest(PRODUCT.CONTAINER).remove())
			.then(() => CalcProductsQuantity())
			.then(() => executeTotalCalculations())
		if (PRODUCT.CONTAINER.length == 0) {
			$(CLEAR_ALL_PRODUCTS).hide(250);
			$(FORM).hide(250);
		}
	}

	function ClearAllProductsFromCart() {
		CartService.clear(lang)
			.done((response) => cartChangeHandler(response))
			.then(() => updateDeliveryTime())
			.then(() => $(Selector.CART.EMPTY_INFO).show(250))
			.then(() => $(FORM).hide(250))
		$(Selector.CART_ICON.COUNT).hide().html('0');
		CalcProductsQuantity();
	}

	function IncreaseProdQuantity(this) {
		let currentInput = $(this).next('input')[0];
		let { $this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat } = CartCommon.extractFullCommonData(currentInput);
		let { row, price, total } = CartCommon.extractRowCommonData($this);

		if (quantity.greaterThanOrEqualTo(maxQuantity)) {
			Notifications.add(Message.MAX_PRODUCT_LIMIT, "info");
			return false;
		} else {
			quantity = quantity.plus(step);
			$this.val(quantity.toFixed(unitIsFloat));
			total.text(formatCurrency(price * quantity.toNumber()));
			total.attr('data-total-price', price * quantity.toNumber());
			row.find('button').attr('disabled', 'disabled');
			CartService.update(productId, quantity.toNumber())
				.done($result => {
					const pure_value: number = CartCommon.prepareResultValueAsFloat($result.value.total);
					$this.val(quantity.toFixed(unitIsFloat));
					total.text(formatCurrency(price * quantity.toNumber()));
					total.attr('data-total-price', price * quantity.toNumber());
					row.find('button').removeAttr('disabled');

					$(SUMMARY_PANEL.TOTAL).html(String($result.value.total));
					$(SUMMARY_PANEL.TOTAL).attr('data-value', pure_value); //necessary to update delivery bar
					Step1Component.handleDeliveryBarUpdate(pure_value, $result);
					// if there are any promotions
					// then apply the promotion to total price
					if ($result.cartThreshold.firstThresholdIsCrossed) {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <s>${showPriceWithCurrentCurrency($result.cartThreshold.currentBasketAmount, 2, 'comma')}</s> <br>
                        <span style="color: green;">
                            Razem po rabacie: <br> 
                            <b>${$result.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency}</b>
                        </span>
                        `);
					} else {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <b>${showPriceWithCurrentCurrency($result.cartThreshold.currentBasketAmount, 2, 'comma')}</b>
                        `);
					}
					Promotions.updateValues({
						currentThresholdMin: $result.cartThreshold.currentThreshold,
						currentThresholdMax: $result.cartThreshold.nextGreatestThreshold,
						remainingAmount: $result.cartThreshold.missingAmount,
						currentCartAmount: $result.cartThreshold.currentBasketAmount,
						currentThresholdPercent: $result.cartThreshold.currentPercent,
						nextThresholdPercent: $result.cartThreshold.nextGreatestPercent,
						lastThresholdPercent: $result.cartThreshold.lastPercent
					});
					if ($result.msg != undefined && $result.msg != null) {
						Notifications.add($result.msg, "warning");
					}
				})
		}
	}

	function DecreaseProdQuantity(this) {
		let currentInput = $(this).prev('input')[0];
		let { $this, productId, quantity, minQuantity, maxQuantity, step, unitIsFloat } = CartCommon.extractFullCommonData(currentInput);
		let { row, price, total } = CartCommon.extractRowCommonData($this);

		if (quantity.lessThanOrEqualTo(minQuantity)) {
			return false;
		} else {
			quantity = quantity.minus(step);
			$this.val(quantity.toString());
			total.text(formatCurrency(price * quantity.toNumber()));
			total.attr('data-total-price', price * quantity.toNumber());
			row.find('button').attr('disabled', 'disabled');
			CartService.update(productId, quantity.toNumber())
				.done($result => {
					const pure_value: number = CartCommon.prepareResultValueAsFloat($result.value.total);
					$this.val(quantity.toFixed(unitIsFloat));
					total.text(formatCurrency(price * quantity.toNumber()));
					total.attr('data-total-price', price * quantity.toNumber());
					row.find('button').removeAttr('disabled');
					$(SUMMARY_PANEL.TOTAL).html(String($result.value.total));
					$(SUMMARY_PANEL.TOTAL).attr('data-value', pure_value); //necessary to update delivery bar
					Step1Component.handleDeliveryBarUpdate(pure_value, $result);
					// if there are any promotions
					// then apply the promotion to total price
					if ($result.cartThreshold.firstThresholdIsCrossed) {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <s>${showPriceWithCurrentCurrency(Number($result.cartThreshold.currentBasketAmount), 2, 'comma')}</s> <br>
                        <span style="color: green;">
                            Razem po rabacie: <br> 
                            <b>${$result.cartThreshold.prodsPriceThresholdsPromotionsWithCurrency}</b>
                        </span>
                        `);
					} else {
						$(SUMMARY_PANEL.TOTAL).html(`
                        <b>${showPriceWithCurrentCurrency(Number($result.cartThreshold.currentBasketAmount), 2, 'comma')}</b>
                        `);
					}

					Promotions.updateValues({
						currentThresholdMin: $result.cartThreshold.currentThreshold,
						currentThresholdMax: $result.cartThreshold.nextGreatestThreshold,
						remainingAmount: $result.cartThreshold.missingAmount,
						currentCartAmount: $result.cartThreshold.currentBasketAmount,
						currentThresholdPercent: $result.cartThreshold.currentPercent,
						nextThresholdPercent: $result.cartThreshold.nextGreatestPercent,
						lastThresholdPercent: $result.cartThreshold.lastPercent
					});

					if ($result.msg != undefined && $result.msg != null) {
						Notifications.add($result.msg, "warning");
					}
				})
		}
	}

	function inputKeyupHandler(this, event: JQueryEventObject) {
		CartCommon.inputKeyupHandler(this, event, Message.MAX_PRODUCT_LIMIT);
	}

	function changeProductQuantity() {
		CartCommon.changeProductQuantity(this, Selector.PRODUCT_PAGE.QUANTITY, Message.MAX_PRODUCT_LIMIT)
	}

	function focusoutProductPageProductQuantity() {
		CartCommon.focusoutProductPageProductQuantity(this, Message.MAX_PRODUCT_LIMIT);
	}

	function inputFocusoutHandler() {
		CartCommon.inputFocusoutHandler(this);
	}

	function CalcProductsQuantity() {
		let total: number = $(PRODUCT.CONTAINER).length;
		$(SUMMARY_PANEL.PRODS_QUANTITY).text(total);
	}

	function updateDeliveryTime() {
		CartService.getDeliveryTime().done(msg => {
			$(Selector.CART.DELIVERY_TIME).toggle(!!msg).html(msg);
		});
	}

	function calcTotalQuantities() {
		CartCommon.calcTotalQuantities(PRODUCT.QUANTITY);
	}

	function executeTotalCalculations() {
		calcTotalQuantities();
	}

	function sendFormStepOne(e) {
		if (CartCommon.isAllAjaxComplete === true) {
			$body.off("submit", FORM, sendFormStepOne);
			return $(FORM).submit();
		}
		e.preventDefault();
	}

	$body.on("submit", FORM, sendFormStepOne);
	$body.on("click", Selector.PRODUCT_TILE.ADD_ITEM, ProdTileAddToCart);
	// $body.on("click", Selector.CATEGORY_PAGE.ADD_ITEM, ProdPageAddToCart);
	// $body.on("click", Selector.PRODUCT_PAGE.ADD_ITEM, ProdPageAddToCart);
	$body.on("click", Selector.PRODUCT_PAGE.INCREASER, changeProductQuantity);
	$body.on("click", Selector.PRODUCT_PAGE.DECREASER, changeProductQuantity);
	$body.on("focusout", Selector.PRODUCT_PAGE.QUANTITY, focusoutProductPageProductQuantity);
	// Step1 Selectors below
	$body.ready(CalcProductsQuantity);
	$body.on("click", CLEAR_ALL_PRODUCTS, ClearAllProductsFromCart);
	$body.on("click", PRODUCT.REMOVE, RemoveFromCart);
	$body.on("keyup", PRODUCT.QUANTITY, inputKeyupHandler);
	$body.on("keyup", PRODUCT.QUANTITY, executeTotalCalculations);
	$body.on("focusout", PRODUCT.QUANTITY, inputFocusoutHandler);
	$body.on("focusout", PRODUCT.QUANTITY, executeTotalCalculations);
	$body.on("click", PRODUCT.QUANTITY_CONTROL_INCREASE, IncreaseProdQuantity);
	$body.on("click", PRODUCT.QUANTITY_CONTROL_DECREASE, DecreaseProdQuantity);
	$body.on('click', PRODUCT.QUANTITY_CONTROL_INCREASE, executeTotalCalculations);
	$body.on('click', PRODUCT.QUANTITY_CONTROL_DECREASE, executeTotalCalculations);

	return true;
})();

export {
	ValidationModule,
	Step1Component,
	Step2Component,
	Step3Component,
	FinalComponent,
	CartShowMoreBtn,
	GuestModal,
	AddCartModal
}
